var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#252424",
  fillRule: "evenodd",
  d: "M5.764 0 7.64 3.808l3.903.772L8.81 7.715 9.336 12l-3.572-1.871L2.207 12l.525-4.285L0 4.58l3.888-.772z",
  clipRule: "evenodd"
})));
export default SvgStar;